import { defineMessages } from 'react-intl';

export const messages: {
	readonly copyLabel: {
		readonly id: 'rovo-chat.view-agent.agent-instructions.copy-label';
		readonly defaultMessage: 'Copy';
		readonly description: 'Label for copy instructions button';
	};
	readonly copyInstructionsTooltip: {
		readonly id: 'rovo-chat.view-agent.agent-instructions.copy-tooltip';
		readonly defaultMessage: 'Copy instructions';
		readonly description: 'Label for copy instructions tooltip';
	};
	readonly noInstructionPlaceholder: {
		readonly id: 'rovo-chat.view-agent.agent-instructions.placeholder';
		readonly defaultMessage: 'This agent has no custom instructions';
		readonly description: 'Placeholder for no instructions';
	};
} = defineMessages({
	copyLabel: {
		id: 'rovo-chat.view-agent.agent-instructions.copy-label',
		defaultMessage: 'Copy',
		description: 'Label for copy instructions button',
	},
	copyInstructionsTooltip: {
		id: 'rovo-chat.view-agent.agent-instructions.copy-tooltip',
		defaultMessage: 'Copy instructions',
		description: 'Label for copy instructions tooltip',
	},
	noInstructionPlaceholder: {
		id: 'rovo-chat.view-agent.agent-instructions.placeholder',
		defaultMessage: 'This agent has no custom instructions',
		description: 'Placeholder for no instructions',
	},
} as const);
